// extracted by mini-css-extract-plugin
export default {"detail":"Detail_detail__p1OWW","size--large":"Detail_size--large__-191F","weight--bold":"Detail_weight--bold__v4PPz","label":"Detail_label__kv7+0"};